// theirs
import { motion } from 'framer-motion'
import classNames from 'classnames'

// ours
import { ContentDataModel } from '../../../interfaces'
import {
    StyledTitleTextAndFeatureImage,
    titleTextAndFeatureImageBaseClass,
} from './style'
import { animationVariants } from '../../../animations'

export interface TitleTextAndFeatureImageProps {
    className?: string
    testId?: string
    content: ContentDataModel
    animationControls?: any
}

const TitleTextAndFeatureImage = ({
    className,
    testId,
    content,
    animationControls,
}: TitleTextAndFeatureImageProps) => {
    return (
        <StyledTitleTextAndFeatureImage
            className={classNames(titleTextAndFeatureImageBaseClass, className)}
            data-testid={testId}
            content={content}
        >
            <div className="content-outer">
                <div className="content-inner">
                    {content.contentTitle && (
                        <motion.div
                            initial="hidden"
                            animate={animationControls}
                            variants={animationVariants.mainTitle}
                            className="title-wrapper"
                        >
                            <h2>{content.contentTitle}</h2>
                        </motion.div>
                    )}
                    {content.contentText && (
                        <motion.div
                            initial="hidden"
                            animate={animationControls}
                            variants={
                                animationVariants.paragraphContainerSlowDelayed
                            }
                            className={`text-wrapper ${content.contentTitle
                                ?.replace(' ', '-')
                                .toLocaleLowerCase()}`}
                        >
                            <p>
                                {content.contentText
                                    .replace(/<\/br>/gi, ' </br> ') //
                                    .replace(/<i>/gi, ' <i>')
                                    .replace(/<\/i>/gi, '</i> ')
                                    .replace(/<b>/gi, ' <b>')
                                    .replace(/<\/b>/gi, '</b> ')
                                    .replace(/\s\s+/g, ' ')
                                    .split(' ')
                                    .map((elements, index) => {
                                        return elements === '</br>' ? (
                                            <br key={index} />
                                        ) : (
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    fontWeight:
                                                        elements.includes('<b>')
                                                            ? 'bold'
                                                            : undefined,
                                                    fontStyle:
                                                        elements.includes('<i>')
                                                            ? 'italic'
                                                            : undefined,
                                                }}
                                                key={index}
                                            >
                                                <motion.span
                                                    variants={
                                                        animationVariants.paragraphItem
                                                    }
                                                >
                                                    {`${elements
                                                        .replace(/<\/br>/gi, '')
                                                        .replace(/<i>/gi, '')
                                                        .replace(/<\/i>/gi, '')
                                                        .replace(/<b>/gi, '')
                                                        .replace(
                                                            /<\/b>/gi,
                                                            ''
                                                        )} `}
                                                </motion.span>
                                            </span>
                                        )
                                    })}
                            </p>
                        </motion.div>
                    )}
                </div>
                <div
                    className={`feature-image ${content.contentTitle
                        ?.replace(' ', '-')
                        .toLocaleLowerCase()}`}
                ></div>
            </div>
        </StyledTitleTextAndFeatureImage>
    )
}

export default TitleTextAndFeatureImage
